import { defineMessages } from 'react-intl';

const messages = defineMessages({
    namePlaceholder: {
        id: 'EmailPasswordSignUpForm.namePlaceholder',
        defaultMessage: 'Enter your name',
        description: 'Placeholder for the name input in the sign up form',
    },
    emailPlaceholder: {
        id: 'EmailPasswordSignUpForm.emailPlaceholder',
        defaultMessage: 'Enter your email',
        description: 'Placeholder for the email input in the sign up form',
    },
    passwordPlaceholder: {
        id: 'EmailPasswordSignUpForm.passwordPlaceholder',
        defaultMessage: 'Enter your password',
        description: 'Placeholder for the password input in the sign up form',
    },
});

export default messages;
